import { useTranslation } from "react-i18next";
import { Divider, Form, Grid, GridColumn, Icon, Modal } from "semantic-ui-react";

import { Can } from "components";
import { createFormHelper } from "lib/Form";

import type { CreateEditKeyLockerFormValues } from "modules/KeyLockersDashboard/components/CreateEditKeyLockerModal";

type CreateEditKeyLockeModalFormProps = {
  hasErrors: boolean;
  isCreatingEditingKeyLocker: boolean;
  isEdit?: boolean;
  onClose: () => void;
  onSubmit: (values: CreateEditKeyLockerFormValues) => void;
};

const FormHelper = createFormHelper<CreateEditKeyLockerFormValues>();

export const CreateEditKeyLockerForm = ({ hasErrors, onClose, onSubmit, isCreatingEditingKeyLocker, isEdit }: CreateEditKeyLockeModalFormProps) => {
  const { t } = useTranslation();
  const { watch, handleSubmit } = FormHelper.useFormContext();

  const name = watch("name");

  return (
    <>
      <Modal.Header className="padding-container">
        <div className="header-container">
          <span className="header-title"> {`${isEdit ? t("v8_edit_key_locker", "Edit Key Locker") : t("v8_add_key_locker", "Add Key Locker")}`} </span>
        </div>
      </Modal.Header>

      <Divider fitted />
      <Modal.Content className="padding-container">
        <Grid columns="equal">
          <GridColumn>
            <Form.Field required error={!name && hasErrors}>
              <label>{t("v8_name", "Name")} </label>
              <FormHelper.Field.Input name="name" inputProps={{ placeholder: t("v8_name", "Name"), fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>
        <Grid columns="equal">
          <GridColumn>
            <Form.Field>
              <FormHelper.Field.Checkbox name="is_2fa_to_drop_key_enabled" label={t("v8_2_factor_authentication_to_drop_key", "2 factor authentication to drop key")} />
            </Form.Field>
          </GridColumn>
        </Grid>
      </Modal.Content>
      <Divider fitted />

      <Modal.Actions className="padding-container">
        <div className="save-cancel-buttons-container">
          <Form.Button className="light" onClick={onClose}>
            {t("v8_cancel", "Cancel")}
            <Icon className="xmark" />
          </Form.Button>
          <Can I="create" the="keylockers">
            <Form.Button type="submit" color="green" disabled={isCreatingEditingKeyLocker} loading={isCreatingEditingKeyLocker} onClick={handleSubmit(d => onSubmit(d))}>
              {t("v8_save", "Save")}
              <Icon className="check" />
            </Form.Button>
          </Can>
        </div>
      </Modal.Actions>
    </>
  );
};
